"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 19.5a2.34 2.34 0 0 1-1.73-.78L.46 7.57a1.85 1.85 0 1 1 2.77-2.44l8.58 9.75a.25.25 0 0 0 .38 0l8.58-9.75a1.85 1.85 0 1 1 2.77 2.44l-9.81 11.15a2.34 2.34 0 0 1-1.73.78Z"
}), 'ChevronDown');

exports.default = _default;